// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30W8g","content":"styles_content__38t14"};